import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DistrictDTO} from '../../../../shared/dto/district.model';
import {CityDTO} from '../../../../shared/dto/city.model';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DistrictService} from '../../../../shared/service/district.service';
import {CityService} from '../../../../shared/service/city.service';
import swal from "sweetalert2";
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-city-popup',
  templateUrl: './city-popup.component.html',
  styleUrls: ['./city-popup.component.scss']
})
export class CityPopupComponent implements OnInit {
  @Input() cityMgtCopy_: CityDTO[];
  public cityMgt: any;
  public cityPopup: FormGroup;
  public districtModel: DistrictDTO[] = [];
  public selectedState: string;
  ActionMode = ActionMode;
  public code: string;
  public description: string;
  public district: string;
  public selectedMode;
  public href: string = "";

  constructor(public modalService: NgbModal,
              public activeModal: NgbActiveModal,
              public districtService: DistrictService,
              public cityService: CityService,
              public tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.cityPopup = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
      district: new FormControl(null),
    });
    this.href = this.router.url;
    this.cityMgt = {...this.cityMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.cityPopup.disable();
    }

    this.loadDistricts();
  }

  loadDistricts() {
    this.districtService.getAllDistricts().subscribe(
      (data: DistrictDTO[]) => {
        this.districtModel = data;
      }
    );
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const cityDTO: CityDTO = new CityDTO(
            this.code,
            this.description,
            this.selectedState,
            this.district,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.cityService.saveCityDetails(cityDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

}
